import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import {
  DEFAULT_RANGE_USD,
  computeDesovaOrders,
} from './domain/computeDesovaOrders'

function toLongLots(ledger) {
  return Object.values(ledger || {})
    .filter((u) => u && u.bucket === 'manual' && Number(u.current?.qty || 0) > 0)
    .map((u) => ({
      id: u.unitID || `long-${u.current?.avgPrice}`,
      price: Number(u.current?.avgPrice || 0),
      qty: Number(u.current?.qty || 0),
    }))
}

function toShortLots(shortLedger) {
  return Object.values(shortLedger || {})
    .filter((u) => u && u.status === 'active' && Number(u.remainingQty || u.origin?.qty || 0) > 0)
    .map((u) => ({
      id: u.shortUnitID || `short-${u.origin?.sellPrice || u.sellPrice}`,
      price: Number(u.origin?.sellPrice || u.sellPrice || 0),
      qty: Number(u.remainingQty || u.origin?.qty || 0),
    }))
}

export function useDesovaOrders() {
  const store = useStore()

  const visible = ref(true)
  const rangeUsd = ref(DEFAULT_RANGE_USD)
  const showFirstSpread = ref(true)
  const showRestSpreads = ref(false)

  const targetPct = computed(() => store.getters.targetPctFrac || 0.006)
  const storePrice = computed(
    () => store.state.marketData?.btcUsd || store.state.marketData?.price || 0
  )
  const longs = computed(() => toLongLots(store.state.ledger))
  const shorts = computed(() => toShortLots(store.state.shortLedger))

  function snapshotAt(marketPrice) {
    const price = Number(marketPrice) > 0 ? Number(marketPrice) : storePrice.value
    return computeDesovaOrders({
      longs: longs.value,
      shorts: shorts.value,
      marketPrice: price,
      targetPct: targetPct.value,
      rangeUsd: rangeUsd.value,
    })
  }

  function toggleVisible() {
    visible.value = !visible.value
  }

  function toggleFirstSpread() {
    showFirstSpread.value = !showFirstSpread.value
  }

  function toggleRestSpreads() {
    showRestSpreads.value = !showRestSpreads.value
  }

  function handleKeyDown(e) {
    if (e.target && ['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName)) return
    if (e.key === 'd' || e.key === 'D') toggleVisible()
  }

  onMounted(() => {
    window.addEventListener('keydown', handleKeyDown)
  })

  onUnmounted(() => {
    window.removeEventListener('keydown', handleKeyDown)
  })

  return {
    visible,
    rangeUsd,
    showFirstSpread,
    showRestSpreads,
    toggleVisible,
    toggleFirstSpread,
    toggleRestSpreads,
    snapshotAt,
  }
}
